import React, { Component } from 'react';
import { Button, Card, Grid, withStyles, Chip } from '@material-ui/core';
import MainContext from '../MainContext';
import { CHANNEL, CHANNEL_DP, COMMON_IMG } from '../constants';

const moment = require('moment');

const styles = (theme) => ({
  card: {
    borderRadius: '5px',
    minHeight: '200px',
    // minHeight: '300px',
    position: 'relative',
  },
  cardGrid: {
    backgroundColor: '#ffffff',
    padding: '20px',
    minHeight: '200px',
    // minHeight: '300px',
    [theme.breakpoints.down('sm')]: {
      padding: '10px',
      // minHeight: 'auto',
      minHeight: '240px',
    },
  },

  enterBtn: {
    color: '#ffffff',
    // height: '100px',
    height: '75px',
    fontSize: '14px',
    fontWeight: 'bold',
    backgroundColor: theme.palette.third.main,
    textTransform: 'none',
    [theme.breakpoints.down('sm')]: {
      height: '60px',
      width: '100%',
      position: 'absolute',
      bottom: 0,
    },
    // '&:focus': {
    //   backgroundColor: theme.palette.secondary.main,
    // },
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
    '& span': {
      fontSize: '20px',
    },
  },

  chip: {
    fontWeight: 'bold',
    color: '#ffffff',
  },
});

class ChannelItem extends Component {
  static contextType = MainContext;
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      detailDialog: false,
      matches: window.matchMedia('(max-width:600px)').matches,
    };
    // this.getProgram = this.getProgram.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  componentDidMount() {
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia('(max-width:600px)').addListener(handler);
  }

  componentWillUnmount() {
    const handler = (e) => this.setState({ matches: e.matches });
    window.matchMedia('(max-width:600px)').removeListener(handler);
  }

  onClose() {
    this.setState({ open: false });
  }

  openNoticeDialog = (event) => {
    this.setState({ detailDialog: true });
  };
  closeNoticeDialog = (event) => {
    this.setState({ detailDialog: false });
  };

  render() {
    const { classes } = this.props;
    return (
      <Grid key={this.props.data} item xs={12} sm={4}>
        <Card variant="outlined" className={classes.card}>
          <Grid className={classes.cardGrid}>
            <Grid>
              <div
                style={{ color: this.props.theme.palette.third.main, fontWeight: 'Bold', fontSize: this.state.matches ? '1.6em' : '2em' }}
              >
                {this.props.data && this.props.data.channel ? CHANNEL_DP[CHANNEL.indexOf(this.props.data.channel)] : ''}
              </div>
            </Grid>
            <Grid style={{ paddingLeft: '10px' }}>
              <div
                style={{
                  //  color: this.props.theme.palette.secondary.main,
                  color: '#de3e36',
                  fontWeight: '700',
                }}
              >
                {this.context.arrDate ? moment(this.context.arrDate[this.context.dayIndex]).format('MMMM DD (ddd.)') : ''}
                {this.props.data && this.props.data.startTime ? ' ' + this.props.data.startTime + '-' + this.props.data.endTime : ''}
              </div>
            </Grid>
            <Grid style={{ padding: '10px' }}>
              <div style={{ color: '#343434', fontWeight: 'bold' }}>{this.props.data ? this.props.data.pgTitle : ''}</div>
            </Grid>
            <Grid style={{ paddingLeft: '10px', height: 20 }}>
              <div style={{ color: '#343434' }}>{this.props.data ? this.props.data.pgSub : ''}</div>
            </Grid>
            <Grid style={{ padding: '10px', height: 20 }}>
              {this.props.detail && this.props.detail[0].isEng ? <Chip label="ENG" color={'primary'} className={classes.chip} /> : ''}
            </Grid>
          </Grid>
          <Button
            fullWidth
            onClick={() => {
              this.props.onEnterHandler(this.props.data);
            }}
            color={'primary'}
            className={classes.enterBtn}
          >
            <img src={`${COMMON_IMG}/ic_entBtn.png`} style={{ marginRight: '10px' }} alt={'enter'} />
            <span>Enter</span>
          </Button>
        </Card>
      </Grid>
    );
  }
}
export default withStyles(styles, { withTheme: true })(ChannelItem);
